import { render } from "./InfoIcon16.vue.js?vue&type=template&id=e6f68a42!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./InfoIcon16.vue?vue&type=template&id=e6f68a42"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__